
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Blog from "../pages/Blog/Blog";
import Blog1 from "../pages/Blog1/Blog";
import Home from "../Home";

import About from '../pages/about';
import Contact from '../pages/contact';
import Gallery from '../pages/gallery';
import Video from '../pages/video';
import Artist from '../pages/artist';
import ArtistDetails from '../pages/artist/details';
import TopDetination from '../pages/Destinations';
import TopDetinationDetail from '../pages/Destinations/Detail';
import GroupTours from '../pages/Tours';
import GroupToursDetails from '../pages/Tours/Details';
import ExperienceList from '../pages/Experience';
import ExperienceDetails from '../pages/Experience/Details';
import Testimonial from '../pages/Testimonials/Testimonial';
import Header from "../Header";
import Footer from "../Footer";
import BlogHeader from "../pages/Blog1/Header";
import BlogFooter from "../pages/Blog1/Footer";
import { useEffect, useState } from "react";
import BlogDetail from "../pages/Blog/BlogDetail";
import BlogDetail1 from "../pages/Blog1/BlogDetail";
import MobileHeader from "../MobileHeader";
import BookingForm from "../pages/Enquire/BookingForm";
import SearchList from "../pages/search/SearchList";
import Author from "../pages/Blog1/Author";

function AppContent() {
  const location = useLocation();
  const [headerData, setHeaderData] = useState(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [isHeader, setIsHeader] = useState(true);

  const isBlogPage = location.pathname.startsWith('/blog1');

  return (
    <>
      {isBlogPage ? (
        <BlogHeader />
      ) : (
        <Header setHeaderData={setHeaderData} setIsHeader={setIsHeader} setMobileMenu={setMobileMenu} mobileMenu={mobileMenu} />
      )}
      <Routes>
        <Route path="/" element={<Home headerData={headerData} />} />
        {/* <Route path="/blog/:id/:name" element={<BlogDetail headerData={headerData} />} /> */}
        {/* <Route path="/blog1/:id/:name" element={<BlogDetail1 headerData={headerData} />} /> */}
        <Route path="/experience/:id/:name" element={<ExperienceDetails headerData={headerData} />} />
        <Route path="/tour/:id/:name" element={<GroupToursDetails headerData={headerData} isHeader={isHeader} />} />
        <Route path="/destinations/:id/:name" element={<TopDetinationDetail headerData={headerData} isHeader={isHeader} />} />
        <Route path="/destinations/:id/:name/:class" element={<TopDetinationDetail headerData={headerData} isHeader={isHeader} />} />
        <Route path="/top-destinations" element={<TopDetination headerData={headerData} />} />
        <Route path="/group-tours" element={<GroupTours headerData={headerData} />} />
        <Route path="/experience" element={<ExperienceList headerData={headerData} />} />
        {/* <Route path="/blog" element={<Blog headerData={headerData} />} /> */}
        {/* <Route path="/blog1" element={<Blog1 headerData={headerData} />} /> */}
        {/* <Route path="/blog1/author" element={<Author headerData={headerData} />} /> */}
        <Route path="/about" element={<About />} />
        <Route path="/testimonial" element={<Testimonial />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/booknow" element={<BookingForm />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/artist" element={<Artist />} />
        <Route path="/artist/:id/:name" element={<ArtistDetails />} />
        <Route path="/search" element={<SearchList />} />
        <Route path="/testimonial/hear_from_our_guests" element={<Video />} />
      </Routes>
      {isBlogPage ? (
        <BlogFooter />
      ) : (
        <Footer headerData={headerData} />
      )}
    </>
  );
}

export default function Router() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}